module.exports = "https://static.wanderu.com/static/media/cnn-money-x2.23b19cb9.png";